import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_37_0 = () => {
  return (
    <div>
      <PageTitle title='3.37.0' />

      <ParaTitle paraTitle='Tutorial & Bug Fixes' />
      <Paragraph paragraph='2025-01-23' />
      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>New tutorial website
          <p>A dedicated hosting environment has been set up for the TSN tutorial web page, separating it from the main TSN repository. This separation allows for easier updates to the tutorial page, ensuring it can quickly reflect new TSN feature releases.</p>
        </li>
        <li>Notify managers when users get locked out 
          <p>Facility managers are now automatically notified when a user is locked out due to too many failed login attempts.</p>
        </li>
      </ul>
      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Directors cannot be assigned in the Independent Organization</li>
        <li>Summary report questions UI formatting
          <p>The Question Summary Report UI has been updated with the following changes:</p>
          <p>Added a form title for the form type, positioned before the dropdown on the right.</p>
          <p>Re-arranged the layout for improved usability and clarity.</p>
        </li>
      </ul>
      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>TSN help desk ticket bug</li>
        <li>User filtering bug</li>
        <li>Orphan notifications bug</li>
        <li>Email image bug</li>
      </ul>
      <Pagination
                pagination={{
                    prev: { name: 'Updates: 3.38.0', link: '/updates/3.38.0' },
                    next: { name: 'Events Summary', link: '/general/events-summary' }
                }}
            />
    </div>

  )
}

export default Updates_3_37_0;